import { useContext } from 'react';
import { AlertContext, AlertProps } from '@components/alert';

function useNotify(): (props: AlertProps) => void {
    const { notify } = useContext(AlertContext);
    return notify;
}

export default useNotify;
